import { render, staticRenderFns } from "./HuongDanVienDaDanForm.vue?vue&type=template&id=489fc871"
import script from "./HuongDanVienDaDanForm.vue?vue&type=script&lang=js"
export * from "./HuongDanVienDaDanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports